<template>
  <div class="cms-content">
  </div>
</template>


<script>
export default {
  name: 'cms-content',
  props: {
    content: String
  }
};
</script>

<style lang="scss">
.cms-content {
  font: 1em/2 $roboto-font-stack;

  p {
    margin: 0;
  }

  a {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      display: block;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 1px;
      background-color: $text-color;
      transform: scale3d(1, 1, 1);
      transform-origin: bottom left;
      transition: transform 0.5s $easeOutQuart;
    }

    &:hover {
      &:after {
        transform-origin: bottom right;
        transform: scale3d(0, 1, 1);
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// CMSContent.vue?4ec42245